import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/context/AuthContext';
import { CompanyService } from '@/services/companyService';

const companyService = new CompanyService();

const companyListQueryKey = (userId: string | undefined) => ['companies', 'switcher', userId] as const;

/** Every company the user can switch to. Fetched only while the picker is open (`enabled`). */
export function useCompanyList(enabled: boolean) {
  const { user } = useAuth();
  return useQuery({
    queryKey: companyListQueryKey(user?.id),
    queryFn: () => companyService.getAllCompanies(),
    enabled: enabled && !!user?.id,
  });
}
